Collection = require('./collection')
Model = require('./Model').default

module.exports = class Version extends Model
    initialize: ->
        #console.log('stereotype inited', @, @attributes.fields.getDefaultIndex())
				



// WEBPACK FOOTER //
// ./app/models/Version.coffee